<template>
  <div class="yjh-navbar">
    <div class="nav-logo">
      <span>代理运营管理后台</span>
    </div>
    <div class="nav-menu">
      <div class="nav-menu-item"
        :class="{'active': $route.meta.factory !== 'standLib' && $route.meta.factory !== 'report'}"
        v-if="dshMenu.length !== 0"
        @click="gotoFirstDsh"
      >控制台</div>
      <div class="nav-menu-item"
        :class="{'active': $route.meta.factory === 'report'}"
        v-if="reportMenu.length !== 0"
        @click="gotoFirstReport"
      >统计结算</div>
      <div class="nav-menu-item"
        :class="{'active': $route.meta.factory === 'standLib'}"
        v-if="libMenu.length !== 0"
        @click="gotoFirstLib"
      >标准库</div>
    </div>
    <Menu class="user-info"
      mode="horizontal"
      @on-select="toggleMenu">
      <Submenu name="account">
        <template slot="title">
          <div class="nav__username">
            <i class="yjh-icon iconfont iconyonghu"></i>
            <span>{{sellerName}}</span>
          </div>
        </template>
        <MenuItem name="accountList" v-show="isAdmin === '1'">账号权限</MenuItem>
        <MenuItem name="newPassword">修改密码</MenuItem>
        <MenuItem name="login" class="logout-link">退出登录</MenuItem>
      </Submenu>
    </Menu>
  </div>
</template>
<script>
import { exitLogin } from '@/api/app'
import { mapState } from 'vuex'
export default {
  name: 'navbar',
  data: function() {
    return {}
  },
  computed: {
    ...mapState({
      isAdmin: state => state.user.isAdmin,
      sellerName: state => state.user.sellerName
    }),
    reportMenu() {
      return this.$store.state.user.roles.filter(item => {
        return item.tab === 'reportTab'
      })
    },
    dshMenu() {
      return this.$store.state.user.roles.filter(item => {
        return item.tab === 'dshTab'
      })
    },
    libMenu() {
      return this.$store.state.user.roles.filter(item => {
        return item.tab === 'libTab'
      })
    }
  },
  mounted() {
    this.$store.commit('SET_RETURN_FULLURL', this.$route.fullPath)
    localStorage.setItem('returnPath', this.$route.fullPath)
  },
  watch: {
    $route() {
      this.$store.commit('SET_RETURN_FULLURL', this.$route.fullPath)
      localStorage.setItem('returnPath', this.$route.fullPath)
    }
  },
  methods: {
    toggleMenu(menu) {
      // 本地存储账号权限返回路径
      localStorage.setItem('returnPath', this.$route.fullPath)
      if (this.$route.params.type !== undefined) {
        localStorage.setItem('routeParams', this.$route.params.type)
      }
      // 退出接口调用（暂无）
      if (menu !== 'login') {
        // 跳转
        this.$router.push({ name: menu })
      } else {
        exitLogin().then(res => {
          if (res.code === 0) {
            localStorage.removeItem('token')
            this.$store.dispatch('emptyRoles', [])
            // window.location.replace(window.location.href.split('#')[0] + '#/login')
            this.$router.push({ name: menu })
            window.location.reload()
          }
        })
      }
    },
    gotoFirstReport() {
      if (this.reportMenu.length === 0) {
        return
      }
      this.$router.push({ path: this.reportMenu[0].url })
    },
    gotoFirstDsh() {
      if (this.dshMenu.length === 0) {
        return
      }
      this.$router.push({ path: this.dshMenu[0].url })
    },
    gotoFirstLib() {
      if (this.libMenu.length === 0) {
        return
      }
      this.$router.push({ path: this.libMenu[0].url })
    }
  }
}
</script>

<style lang="scss" scoped="">
  .yjh-navbar {
    height: 70px;
    background: url("../../../assets/nav.png");
    width: 100%;
    min-width: 1200px;
  }
  .nav-logo {
    display: inline-block;
    padding: 19px 310px 19px 20px;
    position: relative;
    img {
      width: 33px;
      height: 33px;
    }
    span {
      left: 20px;
      top: -7px;
      color: #FFF;
      position: absolute;
      font-size: 20px;
      font-weight: 700;
    }
  }
  .nav-menu {
    display: inline-block;
  }
  .nav-menu-item {
    cursor: pointer;
    & + & {
      margin-left: 100px;
    }
  }
  .nav-menu-item {
    display: inline-block;
    color: #fff;
    font-size: 18px;
    font-weight: 500;
    line-height: 70px;
    position: relative;
    &.active:after {
      content: '';
      position: absolute;
      height: 2px;
      width: calc(100% - 16px);
      background: #fff;
      bottom: 1px;
      left: 8px;
    }
  }
  .user-info {
    position: absolute;
    right: 0;
    display: inline-block;
    background: transparent;
    color: #fff;
    height: 70px;
    line-height: 70px;
    &:after {
      display: none;
    }
  }
  .nav__username {
    .yjh-icon {
      color: #fff;
      font-size: 28px;
      width: 28px;
      height: 28px;
      line-height: 28px;
    }
  }
</style>
<style lang="scss">
  .user-info {
    &.ivu-menu-light.ivu-menu-horizontal .ivu-menu-submenu {
      border-bottom: none;
      color: #fff;
      font-size: 12px;
      padding-left: 18px;
      padding-right: 42px;
      position: relative;
    }
    .ivu-menu-submenu-title > i.ivu-icon-ios-arrow-down {
      display: none;
    }
    .ivu-select-dropdown {
      margin: 2px 0;
      padding: 8px 10px 4px;
      font-size: 12px !important;
      min-width: 160px;
    }
    &.ivu-menu-horizontal .ivu-menu-submenu .ivu-select-dropdown {
      border-radius: 0;
      box-shadow: 0 4px 6px rgba(135, 150, 176, 0.26);
      .ivu-menu-item {
        font-size: 12px !important;
        padding: 0;
        height: 28px;
        line-height: 28px;
        text-align: center;
        &.ivu-menu-item-selected {
          color: #5D6F80;
        }
        &:hover {
          color: #1881dc;
        }
        &.logout-link {
          margin-top: 8px;
          &:before {
            content: '';
            width: 100%;
            height: 1px;
            background: #D9E2EF;
            display: block;
            position: absolute;
            top: -5px;
          }
        }
      }
    }
  }
</style>
